const investmentFundInformationsLang = {
	title_general: {
		tag: 'investment.fund_informations.title_general',
		fr: 'Caractéristiques',
		en: 'General',
	},
	title_planning: {
		tag: 'investment.fund_informations.title_planning',
		fr: 'Planning',
		en: 'Planning',
	},
	title_labels: {
		tag: 'investment.fund_informations.title_labels',
		fr: 'Labels',
		en: 'Labels',
	},
	title_roles: {
		tag: 'investment.fund_informations.title_roles',
		fr: 'Acteurs',
		en: 'Roles',
	},
	title_strategy: {
		tag: 'investment.fund_informations.title_strategy',
		fr: 'Stratégie',
		en: 'Strategy',
	},
	item_juridical_status: {
		tag: 'investment.fund_informations.item_juridical_status',
		fr: 'Forme juridique',
		en: 'Juridical status',
	},
	item_isin: {
		tag: 'investment.fund_informations.item_isin',
		fr: 'ISIN',
		en: 'ISIN',
	},
	item_currency: {
		tag: 'investment.fund_informations.item_currency',
		fr: 'Devise',
		en: 'Currency',
	},
	item_hurdle: {
		tag: 'investment.fund_informations.item_hurdle',
		fr: 'Hurdle',
		en: 'Hurdle',
	},
	item_targeted_performance: {
		tag: 'investment.fund_informations.item_targeted_performance',
		fr: 'Rendement net cible',
		en: 'Targeted performance',
	},
	item_fund_admin_fees: {
		tag: 'investment.fund_informations.item_fund_admin_fees',
		fr: 'Frais de gestion',
		en: 'Fund Admin fees',
	},
	item_fund_admin_fees_of_actif_net: {
		tag: 'investment.fund_informations.item_fund_admin_fees_of_actif_net',
		fr: "de l'actif net",
		en: 'of net assets',
	},
	item_distribution_frequency: {
		tag: 'investment.fund_informations.item_distribution_frequency',
		fr: 'Fréquence de distribution',
		en: 'Distribution frequency',
	},
	item_distribution_frequency_annual: {
		tag: 'investment.fund_informations.item_distribution_frequency_annual',
		fr: 'Annuelle',
		en: 'Annual',
	},
	item_distribution_frequency_biannual: {
		tag: 'investment.fund_informations.item_distribution_frequency_biannual',
		fr: 'Semestrielle',
		en: 'Biannual',
	},
	item_distribution_frequency_quarterly: {
		tag: 'investment.fund_informations.item_distribution_frequency_quarterly',
		fr: 'Trimestrielle',
		en: 'Quarterly',
	},
	item_distribution_frequency_x_months: {
		tag: 'investment.fund_informations.item_distribution_frequency_x_months',
		fr: 'Tous les mois',
		en: 'Every months',
		plurals: {
			zero: {
				fr: 'Jamais',
				en: 'Never',
			},
			one: {
				fr: 'Tous les mois',
				en: 'Every months',
			},
			other: {
				fr: 'Tous les {{count}} mois',
				en: 'Every {{count}} months',
			},
		},
	},
	item_creation_date: {
		tag: 'investment.fund_informations.item_creation_date',
		fr: 'Date de création',
		en: 'Creation date',
	},
	item_launching_date: {
		tag: 'investment.fund_informations.item_launching_date',
		fr: 'Date de lancement de la part',
		en: 'Share launching date',
	},
	item_agreement_date: {
		tag: 'investment.fund_informations.item_agreement_date',
		fr: "Date d'agrément",
		en: 'Agreement date',
	},
	item_subscription_end_date: {
		tag: 'investment.fund_informations.item_subscription_end_date',
		fr: "Période de souscription (jusqu'au):",
		en: 'Subscription end date',
	},
	item_capital_call_end_date: {
		tag: 'investment.fund_informations.item_capital_call_end_date',
		fr: "Période d'appel de fonds (jusqu'au):",
		en: 'Capital calls end date',
	},
	item_investment_end_date: {
		tag: 'investment.fund_informations.item_investment_end_date',
		fr: "Période d'investissement (jusqu'au):",
		en: 'Investment end date',
	},
	item_closing_dates_x: {
		tag: 'investment.fund_informations.item_closing_dates_x',
		fr: '{{count}} closing',
		en: '{{count}} closing',
		plurals: {
			zero: {
				fr: 'No closing',
				en: 'No closing',
			},
			one: {
				fr: '{{count}}er closing',
				en: '{{count}}st closing',
			},
			two: {
				fr: '{{count}}ème closing',
				en: '{{count}}nd closing',
			},
			few: {
				fr: '{{count}}ème closing',
				en: '{{count}}rd closing',
			},
			other: {
				fr: '{{count}}ème closing',
				en: '{{count}}th closing',
			},
		},
	},
	item_amortization_end_date: {
		tag: 'investment.fund_informations.item_amortization_end_date',
		fr: "Période d'amortissement (jusqu'au):",
		en: 'Amortisation end date',
	},
	item_liquidation_date: {
		tag: 'investment.fund_informations.item_liquidation_date',
		fr: 'Date de liquidation',
		en: 'Liquidation date',
	},
	item_fund_administrator: {
		tag: 'investment.fund_informations.item_fund_administrator',
		fr: 'Gestionnaire administratif',
		en: 'Fund administrator',
	},
	item_management_company: {
		tag: 'investment.fund_informations.item_management_company',
		fr: 'Société de gestion',
		en: 'Management company',
	},
	item_consulting_company: {
		tag: 'investment.fund_informations.item_consulting_company',
		fr: 'Société de conseil',
		en: 'Consulting company',
	},
	item_depository: {
		tag: 'investment.fund_informations.item_depository',
		fr: 'Dépositaire',
		en: 'Depository',
	},
	item_accountants: {
		tag: 'investment.fund_informations.item_accountants',
		fr: 'Commissaire aux comptes',
		en: 'Accountants',
	},
	item_domain: {
		tag: 'investment.fund_informations.item_domain',
		fr: 'Domaine',
		en: 'Domain',
	},
	item_sfdr: {
		tag: 'investment.fund_informations.item_sfdr',
		fr: 'SFDR',
		en: 'SFDR',
	},
	item_classification_AMF: {
		tag: 'investment.fund_informations.item_classification_AMF',
		fr: 'Classification AMF',
		en: 'AMF classification',
	},
	key_classification_AMF_bonds_debt_euro: {
		tag: 'investment.fund_informations.key_classification_AMF_bonds_debt_euro',
		fr: 'Oblig. et autres TC libellés en euros',
		en: 'Bonds and other TC denominated in euros',
	},
	item_risk_level: {
		tag: 'investment.fund_informations.item_risk_level',
		fr: 'Niveau de risque (SRI)',
		en: 'Risk level (SRI)',
	},
	item_valorizer: {
		tag: 'investment.fund_informations.item_valorizer',
		fr: 'Valorisateur',
		en: 'Valorizer',
	},
	item_asset_class: {
		tag: 'investment.fund_informations.item_asset_class',
		fr: "Classe d'actif",
		en: 'Asset class',
	},
	key_asset_class_bonds: {
		tag: 'investment.fund_informations.key_asset_class_bonds',
		fr: 'Obligation',
		en: 'Bonds',
	},
	item_thematic: {
		tag: 'investment.fund_informations.item_thematic',
		fr: 'Thématique',
		en: 'Thematic',
	},
	key_thematic_social: {
		tag: 'investment.fund_informations.key_thematic_social',
		fr: 'Social',
		en: 'Social',
	},
	item_investment_horizon: {
		tag: 'investment.fund_informations.item_investment_horizon',
		fr: 'Horizon de placement',
		en: 'Investment horizon',
	},
	key_investment_horizon_more_than_1_year: {
		tag: 'investment.fund_informations.key_investment_horizon_more_than_1_year',
		fr: '> 1 ans',
		en: '> 1 year',
	},
};

export default investmentFundInformationsLang;
